<template>
    <div>
        <el-radio-group v-model="srlx" @input="srlxInput">
            <el-radio :label="0">公农历</el-radio>
            <el-radio :label="1">朝代</el-radio>
            <el-radio :label="2">自定义</el-radio>
        </el-radio-group>
        <div v-if="srlx == 0">
            公历&nbsp;
            <br v-if="flag == 'app'" />
            <el-select v-model="y" placeholder="请选择年" style="width:110px" @change="yearChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.key" v-for="item in yearData" :key="item.index"></el-option>
            </el-select>
            年
            <br v-if="flag == 'app'" />

            <el-select v-model="m" placeholder="请选择月" style="width:110px;" @change="monthChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.key" v-for="item in monthData" :key="item.index"></el-option>
            </el-select>
            月
            <br v-if="flag == 'app'" />

            <el-select v-model="d" placeholder="请选择日" style="width:110px;" @change="dayChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.key" v-for="item in dayData" :key="item.index"></el-option>
            </el-select>
            日 <el-button @click="zhSolar()" type="primary">转换</el-button> <br />
            农历&nbsp;
            <br v-if="flag == 'app'" />

            <el-select v-model="nly" placeholder="请选择年" style="width:110px;margin-top:10px" @change="nlYearChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.key" v-for="item in yearData" :key="item.index"></el-option>
            </el-select>
            年
            <br v-if="flag == 'app'" />

            <el-select v-model="nlm" placeholder="请选择月" style="width:110px;margin-top:10px" @change="nlMonthChange">
                <el-option value="">请选择</el-option>
                <!-- <el-option v-for="item in nlmonthData" :label="item.name" :value="item.value" :key="item.index"></el-option> -->
                <el-option v-for="item in nlmonthData" :key="item.index" :value="item.value"> </el-option>
            </el-select>
            月
            <br v-if="flag == 'app'" />

            <el-select v-model="nld" placeholder="请选择日" style="width:110px;margin-top:10px" @change="nldayChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.key" v-for="item in dayData" :key="item.index"></el-option>
            </el-select>
            日
            <el-button @click="zhLunar()" type="primary">转换</el-button>
        </div>
        <div v-else-if="srlx == 1">
            朝代 &nbsp;
            <!-- <el-input v-model="cd" placeholder="朝代" style="width:100px;margin-top:10px"></el-input> -->
            <el-select v-model="cd" placeholder="请选择朝代" style="width:110px;margin-top:10px" @change="chaodaiChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.chaodai" v-for="item in chaodaiData" :key="item.index"></el-option>
            </el-select>

            &nbsp;&nbsp;&nbsp; 年号
            <!-- <el-input v-model="nh" placeholder="年号" style="width:100px;margin-top:10px"></el-input> -->
            <el-select v-model="nh" placeholder="请选择年号" style="width:110px;margin-top:10px" @change="nhChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.nianhao" v-for="item in nhData" :key="item.index"></el-option>
            </el-select>
            &nbsp;&nbsp;&nbsp; 农历年份
            <!-- <el-input v-model="gynf" placeholder="公元年份" style="width:100px;margin-top:10px"></el-input> -->
            <el-select v-model="gynf" placeholder="请选择农历年份" style="width:110px;margin-top:10px" @change="gynfChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.gongyuan" v-for="item in nhData" :key="item.index"></el-option>
            </el-select>
            <el-select v-model="month" placeholder="请选择月" style="width:110px;margin-top:10px" @change="cdMonthChangey">
                <el-option value="">请选择</el-option>
                <!-- <el-option :value="item" v-for="item in 12" :key="item.index"></el-option> -->
                <el-option v-for="item in nlmonthData" :key="item.index" :value="item.value"> </el-option>
            </el-select>
            月
            <el-select v-model="day" placeholder="请选择日" style="width:110px;margin-top:10px" @change="cddayChange">
                <el-option value="">请选择</el-option>
                <el-option :value="item.key" v-for="item in cdDayData" :key="item.index"></el-option>
            </el-select>
            日
        </div>
        <div v-else-if="srlx == 2">
            手动录入&nbsp;
            <el-input
                v-model="sdlr"
                placeholder="手动录入(失考、待考、大约朝代、大约年间、大约时间等)"
                style="width:400px;margin-top:10px"
                @input="handlerChange"
            ></el-input>
        </div>
    </div>
</template>

<script>
import api from "@/request/api";

export default {
    props: {
        propssr: {
            type: String
        },
        propsnlsr: {
            type: String
        },
        propscd: {
            type: String
        },
        propsnh: {
            type: String
        },
        propssdlr: {
            type: String
        },
        propsgynf: {
            type: String
        },
        propscdday: {
            type: String
        },
        propscdmonth: {
            type: String
        },
        propssrlx: {
            type: Number
        },
        propskey: {
            type: String
        },
        propskeyType: {
            type: String
        },
        propskeyInd: {
            type: Number
        }
    },
    data() {
        return {
            y: "",
            m: "",
            d: "",
            nly: "",
            nlm: "",
            nld: "",
            cd: "",
            nh: "",
            day: "",
            month: "",
            gynf: "",
            sdlr: "",
            srlx: 0,
            yearData: [],
            monthData: [],
            nlmonthData: [
                { value: "1" },
                { value: "闰1" },
                { value: "2" },
                { value: "闰2" },
                { value: "3" },
                { value: "闰3" },
                { value: "4" },
                { value: "闰4" },
                { value: "5" },
                { value: "闰5" },
                { value: "6" },
                { value: "闰6" },
                { value: "7" },
                { value: "闰7" },
                { value: "8" },
                { value: "闰8" },
                { value: "9" },
                { value: "闰9" },
                { value: "10" },
                { value: "闰10" },
                { value: "11" },
                { value: "闰11" },
                { value: "12" },
                { value: "闰12" }
            ],
            dayData: [],
            chaodai: "",
            chaodaiData: [],
            nhData: [],
            gyyearData: [],
            cdDayData: 31,
            flag: "pc"
        };
    },
    mounted() {
        this.yearData = this.$utils.year();
        if (this.isMobile()) {
            // 手机端
            sessionStorage.setItem("flag", "app");
            this.flag = "app";
        } else {
            // pc端
            sessionStorage.setItem("flag", "pc");
            this.flag = "pc";
        }
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
            );
            return flag;
        },
        srlxInput() {
            console.log(this.srlx);
            this.emitFun();
        },
        zhSolar() {
            // type = 1 是农历转阳历
            // type= 0 是阳历转农历
            api.convertdate(
                this.$qs.stringify({
                    type: 0,
                    year: this.y,
                    month: this.m,
                    day: this.d
                })
            ).then((res) => {
                this.$set(this, "nly", res.data.year);
                this.$set(this, "nlm", res.data.month);
                this.$set(this, "nld", res.data.day);
                this.emitFun();
            });
        },
        zhLunar() {
            api.convertdate(
                this.$qs.stringify({
                    type: 1,
                    year: this.nly,
                    month: this.nlmFun(this.nlm),
                    day: this.nld
                })
            ).then((res) => {
                this.$set(this, "y", res.data.year);
                this.$set(this, "m", res.data.month);
                this.$set(this, "d", res.data.day);
                this.emitFun();
            });
        },
        yearChange(e) {
            this.monthData = this.$utils.month(e);
            this.m = "";
            this.d = "";
            this.emitFun();
        },
        monthChange(e) {
            this.dayData = this.$utils.day(this.y, e);
            this.d = "";
            this.emitFun();
        },
        dayChange() {
            this.emitFun();
        },
        nlYearChange(e) {
            this.monthData = this.$utils.month(e);
            this.nlm = "";
            this.nld = "";
            this.emitFun();
        },
        nlMonthChange(e) {
            this.dayData = this.$utils.day(this.nly, this.nlmFun(e));
            this.nlm = e;
            this.nld = "";
            this.emitFun();
        },
        nldayChange() {
            this.emitFun();
        },
        emitFun() {
            let emitData = {
                y: "",
                m: "",
                d: "",
                sr: "",
                nly: "",
                nlm: "",
                nld: "",
                nlsr: "",
                cd: "",
                nh: "",
                gynf: "",
                month: "",
                day: "",
                sdlr: "",
                srlx: this.srlx,
                key: this.propskey,
                keyType: this.propskeyType,
                keyInd: this.propskeyInd
            };
            if (this.srlx == 0) {
                emitData.y = this.y;
                emitData.m = this.m;
                emitData.d = this.d;
                emitData.sr = this.y + (this.m != "" ? "-" + this.m : "") + (this.d != "" ? "-" + this.d : "");
                emitData.nly = this.nly;
                emitData.nlm = this.nlm;
                emitData.nld = this.nld;
                emitData.nlsr = this.nly + (this.nlm != "" ? "-" + this.nlm : "") + (this.nld != "" ? "-" + this.nld : "");
            } else if (this.srlx == 1) {
                emitData.cd = this.cd;
                emitData.nh = this.nh;
                emitData.gynf = this.gynf;
                emitData.month = this.month;
                emitData.day = String(this.day);
            } else {
                emitData.sdlr = this.sdlr;
            }
            this.$emit("dateFun", emitData);
        },
        handlerChange(e) {
            this.emitFun();
        },
        // 获取朝代
        getchaodai() {
            if (!sessionStorage.getItem("chaodaiData")) {
                api.getchaodai().then((res) => {
                    this.chaodaiData = res.data;
                    sessionStorage.setItem("chaodaiData", this.$qs.stringify(this.chaodaiData));
                });
            } else {
                this.chaodaiData = this.$qs.parse(sessionStorage.getItem("chaodaiData"));
            }
        },
        // 获取年号
        getyear() {
            if (this.cd != "") {
                if (!sessionStorage.getItem("nhData")) {
                    api.getnianhaobychaodai({ chaodai: this.cd }).then((res) => {
                        this.nhData = res.data;
                        sessionStorage.setItem("nhData", this.$qs.stringify(this.nhData));
                    });
                } else {
                    this.nhData = this.$qs.parse(sessionStorage.getItem("nhData"));
                }
            } else {
                if (!sessionStorage.getItem("nhDataAll")) {
                    api.getyear().then((res) => {
                        this.nhData = res.data;
                        sessionStorage.setItem("nhDataAll", this.$qs.stringify(this.nhData));
                    });
                } else {
                    this.nhData = this.$qs.parse(sessionStorage.getItem("nhDataAll"));
                }
            }
        },
        // 选择朝代获取年号
        chaodaiChange(e) {
            this.nh = "";
            this.gynf = "";
            api.getnianhaobychaodai({ chaodai: e }).then((res) => {
                this.nhData = res.data;
            });
            this.emitFun();
        },
        // 选择朝代和年号获取公元年份
        nhChange(e) {
            api.getyearbychaodainianhao({ chaodai: this.cd, nianhao: e }).then((res) => {
                this.gynf = res.data.gongyuan;
                if (this.month != "") {
                    this.cdDayData = this.$utils.day(this.gynf, this.month);
                }
            });
            this.emitFun();
        },
        // 选择公元年份获取朝代和年号
        gynfChange(e) {
            api.getbyyear({ gongyuan: e }).then((res) => {
                this.cd = res.data.chaodai;
                // this.chaodaiChange(this.cd);
                this.nh = res.data.nianhao;
            });
            this.emitFun();
        },
        cdMonthChangey(e) {
            this.cdDayData = this.$utils.day(this.gynf, this.nlmFun(e));
            if (this.data) {
                this.gynf + "-" + this.month + "-" + this.day;
                this.nly = this.gynf;
                this.nlm = this.month;
                this.nld = this.day;
                api.convertdate(
                    this.$qs.stringify({
                        type: 1,
                        year: this.gynf,
                        month: this.nlmFun(e),
                        day: this.day
                    })
                ).then((res) => {
                    this.$set(this, "y", res.data.year);
                    this.$set(this, "m", res.data.month);
                    this.$set(this, "d", res.data.day);
                    this.emitFun();
                });
                this.emitFun();
            }
        },
        cddayChange(e) {
            this.nlsr = this.gynf + "-" + this.month + "-" + e;
            this.nly = this.gynf;
            this.nlm = this.month;
            this.nld = e;
            api.convertdate(
                this.$qs.stringify({
                    type: 1,
                    year: this.gynf,
                    month: this.nlmFun(this.month),
                    day: e
                })
            ).then((res) => {
                this.$set(this, "y", res.data.year);
                this.$set(this, "m", res.data.month);
                this.$set(this, "d", res.data.day);
                this.emitFun();
            });
            this.emitFun();
        },
        nlmFun(e) {
            let m;
            switch (e) {
                case "闰1":
                    m = 1;
                    break;
                case "闰2":
                    m = 2;
                    break;
                case "闰3":
                    m = 3;
                    break;
                case "闰4":
                    m = 4;
                    break;
                case "闰5":
                    m = 5;
                    break;
                case "闰6":
                    m = 6;
                    break;
                case "闰7":
                    m = 7;
                    break;
                case "闰8":
                    m = 8;
                    break;
                case "闰9":
                    m = 9;
                    break;
                case "闰10":
                    m = 10;
                    break;
                case "闰11":
                    m = 11;
                    break;
                case "闰12":
                    m = 12;
                    break;
                default:
                    m = e;
                    break;
            }
            return m;
        }
    },
    watch: {
        propssr: {
            handler(newVal, oldVal) {
                this.sr = newVal;
                if (newVal != undefined && newVal != "" && newVal != null) {
                    if (newVal.split("-").length >= 3) {
                        this.$set(this, "y", newVal.split("-")[0]);
                        this.$set(this, "m", newVal.split("-")[1]);
                        this.$set(this, "d", newVal.split("-")[2]);
                        this.monthData = this.$utils.month(newVal.split("-")[0]);
                        this.dayData = this.$utils.day(newVal.split("-")[0], newVal.split("-")[1]);
                    }
                }
            },
            immediate: true
        },
        propsnlsr: {
            handler(newVal, oldVal) {
                this.nlsr = newVal;
                if (newVal != undefined && newVal != "" && newVal != null) {
                    if (newVal.split("-").length >= 3) {
                        this.$set(this, "nly", newVal.split("-")[0]);
                        this.$set(this, "nlm", newVal.split("-")[1]);
                        this.$set(this, "nld", newVal.split("-")[2]);
                    }
                }
            },
            immediate: true
        },
        propscd: {
            handler(newVal, oldVal) {
                this.cd = newVal;
            },
            immediate: true
        },
        propsnh: {
            handler(newVal, oldVal) {
                this.nh = newVal;
            },
            immediate: true
        },
        propssdlr: {
            handler(newVal, oldVal) {
                this.sdlr = newVal;
            },
            immediate: true
        },
        propsgynf: {
            handler(newVal, oldVal) {
                this.gynf = newVal;
            },
            immediate: true
        },
        propscdday: {
            handler(newVal, oldVal) {
                this.day = newVal;
            },
            immediate: true
        },
        propscdmonth: {
            handler(newVal, oldVal) {
                this.month = newVal;
            },
            immediate: true
        },

        propssrlx: {
            handler(newVal, oldVal) {
                this.srlx = Number(newVal);
                if (newVal == 1) {
                    this.getchaodai();
                    this.getyear();
                }
            },
            immediate: true
        },
        srlx: {
            handler(newVal, oldVal) {
                if (newVal == 1) {
                    this.getchaodai();
                    this.getyear();
                }
            },
            immediate: true
        }
    }
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/date.vue